import { z } from 'zod'

export const partnershipCreationPayloadSchema = z.object({
  name: z.string().nullable(),
  country: z.string().nullable(),
  operatorOrganizationId: z.uuid().nullable().optional(),
  declarantOrganizationId: z.uuid().nullable().optional()
})

export const partnershipInvitationPayloadSchema = z.object({
  email: z.email()
})

export type PartnershipCreationPayload = z.infer<typeof partnershipCreationPayloadSchema>
export type PartnershipInvitationPayload = z.infer<typeof partnershipInvitationPayloadSchema>

export enum PartnershipStatus {
  CREATED = 'CREATED',
  INVITATION_SENT = 'INVITATION_SENT',
  INVITATION_ACCEPTED = 'INVITATION_ACCEPTED',
  INVITATION_REJECTED = 'INVITATION_REJECTED'
}

export enum PartnershipInviterOrganizationType {
  OPERATOR = 'OPERATOR',
  DECLARANT = 'DECLARANT'
}

export type Partnership = {
  id: string
  name: string
  invitationEmail: string
  invitationSentAt: string
  country: string
  operatorOrganizationId: string
  declarantOrganizationId: string
  status: PartnershipStatus
  invitationOrganizationType: PartnershipInviterOrganizationType
  invitationSenderName: string
  invitationSenderEmail: string
  isOffPlatform: boolean
  createdAt: string
  updatedAt: string | null
  invitationRejectedReason: string | null
  invitationRejectedAt: string | null
}

export type DeclarantPartnership = Partnership & {
  operatorStreet?: string
  operatorStreet2?: string
  operatorStreetNumber?: string
  operatorSubDivision?: string
  operatorPostCode?: string
  operatorPoBox?: string
  operatorCity?: string
  operatorContactName?: string
  operatorContactPhoneNumber?: string
  operatorContactEmail?: string
}
